import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Statement.GeneratePdf.IRequest;
type Response = Api.Core.Statement.GeneratePdf.IResponse;
type Headers = Api.Core.Statement.GeneratePdf.IHeaders;
const url = '/api/DealerManagement/Statement/GeneratePdf/:id';
export default async function statementGeneratePdfApi(id: number): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
}
